"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title3: function() {
        return _index.Title3;
    },
    title3ClassNames: function() {
        return _index.title3ClassNames;
    }
});
const _index = require("./components/presets/Title3/index");
